import createStore from "@/utils/create-store";
import Model from "@/models/public/managers";

export default createStore({ Model });
